<script lang="ts">
    import type { IconDefinition } from '@fortawesome/free-solid-svg-icons'
    import { createEventDispatcher } from 'svelte'
    import Fa from 'svelte-fa'
    const dispatch = createEventDispatcher()

    export let color: string = '#333'
    export let background: string = '#fff'
    export let label: string = ''
    export let icon: IconDefinition
    export let style: string = ''
    export let effect: string = ''

    let className = ''
    export { className as class }

    function onClick() {
        dispatch('click')
    }
</script>

<div class="labelled-button {className}" style="--labelled-button-background: {background};{style}">
    {#if label}
        <div style="color:{color};background:{background}" class="box-arrow box-arrow-right">{label}</div>
    {/if}
    <button class={effect} style="color:{color};background:{background}" on:click={onClick}><Fa {color} {icon} /></button>
</div>

<style>
    .labelled-button {
        display: flex;
        align-items: center;
        flex-shrink: 0;
    }
    button {
        border-radius: 50%;
        background-color: white;
        padding: 16px;
        font-size: 20px;
        width: 45px;
        height: 45px;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: rgb(38, 57, 77) 0px 20px 30px -10px;
    }
    button :global(svg) {
        filter: drop-shadow(4px 4px 6px #00000080);
    }
    .box-arrow {
        background-color: var(--labelled-button-background);
        box-shadow: rgb(38, 57, 77) 0px 10px 30px -10px;
        color: #328866;
        padding: 8px 12px;
        position: relative;
        margin-right: 15px;
        float: left;
        border-radius: 16px;
        font-size: 16px;
        cursor: default;
        font-weight: 500;
    }
    .box-arrow-right:after {
        content: ' ';
        position: absolute;
        right: -8px;
        top: 5px;
        border-top: 15px solid transparent;
        border-right: none;
        border-left: 15px solid var(--labelled-button-background);
        border-bottom: 15px solid transparent;
    }

    .shake {
        animation: shake 0.25s infinite;
    }

    @keyframes shake {
        0% {
            transform: rotate(0deg);
        }
        25% {
            transform: rotate(5deg);
        }
        50% {
            transform: rotate(0eg);
        }
        75% {
            transform: rotate(-5deg);
        }
        100% {
            transform: rotate(0deg);
        }
    }

    @media (max-width: 900px) {
        .box-arrow {
            display: none;
        }
    }
</style>
